import { render } from "./userCreate.vue?vue&type=template&id=1a488bcc&scoped=true"
import script from "./userCreate.vue?vue&type=script&lang=js"
export * from "./userCreate.vue?vue&type=script&lang=js"

import "./userCreate.vue?vue&type=style&index=0&id=1a488bcc&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a488bcc"]])

export default __exports__